// extracted by mini-css-extract-plugin
export default {"copyButton":"_2jHpggiXer7kHtosrfHhwe"};